export enum ForecastWarning {
	None = 0,
	MAPE = 1,
	MPE = 2,
	CVStable = 4,
	CVBalanced = 8,
	CVUnstable = 16,
}
